// Environment-based configuration
export const API_URL = process.env.VUE_APP_API_URL || "/api";
export const BASE_URL = process.env.VUE_APP_BASE_URL || "http://localhost:8081";
export const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_CLIENT_SECRET = process.env.VUE_APP_GOOGLE_CLIENT_SECRET; 